/* eslint-disable */

<template>
  <div class="empmyrequests">
    <div class="container-fluid">
      <div class="container-fluid pb-3">
        <h2 class="card-title font-weight-bold">My Requests</h2>
        <AddRequest showZone="true" />
        <div>

          <RequestTable
          :requests="myRequests"
          :shortTable="true"
          :startDate="null"
          :endDate="null"
          type=""
          city=""
        />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb, db, auth } from "../firebase";
import Multiselect from "vue-multiselect";
import AddRequest from "@/components/AddRequest.vue";
import { mapState, mapGetters } from 'vuex'
import RequestTable from "../components/RequestTable.vue";
import {dbSchema} from "../store"

export default {
  name: "EmpMyRequests",
  components: { Multiselect, AddRequest, RequestTable },
  props: {},
  data() {
    return {
      req_address_received: false,
      date: new Date().toISOString(),
      activeItem: null,
      modal: null,
      collapseState: null,
      collapseCustomState: null,
      selected: "",
      selected2: "",
      selectedAddress: "",
      // Custom Add Request Props
      customFullName: null,
      customFirstName: null,
      customLastName: null,
      x: "one",
      y: "one",
      z: "one",
      layout: null,
    };
  },
  computed: {
    ...mapState([
    'bulksettings',
    'myRequests',
    'bulkTypes'
  ]),
    ...mapGetters({
      user: "user"
    })
  },
  created() {
    
    this.collapseState = "shrunk";
    this.collapseCustomState = "hide";
    this.layout = "one";
  },
  methods: {
    sortBulkTypes(bulkTypes, dropEmpty=false) {
      const emptyData = [];
      var types = bulkTypes.filter(item => {
        if(item.name == "" || item.name == null) {
            emptyData.push(item)
            return false;
        }
        return true
      })

      types = types.sort(function (a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();

        if(textA < textB)
            return -1

        if(textA > textB) {
          return 1;
        }

        return 0;
      });

      if(!dropEmpty)
          return types.concat(emptyData);
      else {

        var removedEmpty = types.filter(item => {
        if(item.message == "" || item.message == null) {
            return false;
        }

        if(item.pickup == "" || item.pickup == null) {
            return false;
        }

        return true
      })

      return removedEmpty;

      }
    },
    reset() {
      this.request = {
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        req_phone: null,
        req_email: null,
      };
    },
    async updateProduct() {
      await db.collection(dbSchema.users).doc(this.user.id).collection(dbSchema.requests)
        .doc(this.request.id)
        .update(this.request);
      Toast.fire({
        type: "success",
        title: "Bulk Trash Request Updated",
      });
      $("#product").modal("hide");
      this.reset();
    },
    editProduct(request) {
      this.modal = "edit";
      this.request = request;
      $("#product").modal("show");
    },
    copyRequest(request) {
      // Nothing to put here yet.
      this.request = request;
      var date = new Date();
      var options = {
        weekday: "short",
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };

      options.timeZone = "America/New_York";
      this.request.timestamp = date.toLocaleDateString("en-US", options);
      this.request.req_status = "Submitted";
      db.collection(dbSchema.users).doc(this.user.id).collection(dbSchema.requests).add(this.request);
      Toast.fire({
        type: "success",
        title: "Bulk Trash Request Added",
      });
      $("#product").modal("hide");
      this.reset();
    },
    async deleteProduct(doc) {
      const requestRef = await db.collection(dbSchema.users).doc(this.user.id).collection(dbSchema.requests).get();
      const updateView = this.updateRequests;
      const handleDelete = async (result) => {
        if (result.value) {
          let arrayResult = await requestRef.docs.filter((item) => {
            return item.id == doc.id;
          });
          var deleted = false;

          await arrayResult.forEach((doc) => {
            doc.ref.delete();
            deleted = true;
          });

          if (deleted) {
            Toast.fire({
              type: "error",
              title: "Bulk Trash Request Deleted",
            });
            $("#product").modal("hide");
            try {
              updateView();
            } catch {
            }
          } else {
            Toast.fire({
              type: "error",
              title: "Error Occured While Deleting",
            });
          }
        }
      };
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(handleDelete);
    },
  },
};
</script>

<style scoped lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
